import { Box, Button, Typography, styled } from '@mui/material'
import { selectCurrentInvoice } from 'app/slice/invoice.slice'
import BtnEditUnderline from 'assets/button/BtnEditUnderline'
import { Config } from 'config'
import { logo } from 'constants/images'
import moment from 'moment'
import PageModal from 'new-components/modal/page-modal'
import { ReactNode, useCallback, useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { getClinicInfo, numberFormat } from 'utils/app.utils'
import { dateMonthToView, dateToView } from 'utils/date.utils'

// type Props = {}

export const PDFContainer = styled(Box)(({ theme }) => ({
    width: '297mm',
    height: '420mm',
    backgroundColor: "#fff",
    overflow: "hidden",
    position: 'relative',
    '.pdf-body': {
        padding: '20px 60px',
        height: '100%',
        width: "100%",
        position: 'relative',
        '.pdf-title': {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            paddingTop: '24px',
            '.pdf-branch-logo': {
                height: '100px',
                img: {
                    maxHeight: '100%'
                }
            },
            '.pdf-title-text': {
                fontWeight: 'bolder',
                color: 'blue'
            }
        },
        '.pdf-content': {
            '.pdf-content-date': {
                display: 'flex',
                justifyContent: 'flex-end',
                position: 'relative'
            },
            '.pdf-table-container': {
                marginTop: '8px',
                'table': {
                    width: '100%'
                },
                'table .table-head th': {
                    border: '1px solid blue',
                    textAlign: 'center',
                    padding: '8px 8px ',
                },
                'table .table-body td': {
                    border: '1px solid blue',
                    padding: '8px',
                    height: '24px',
                    minHeight: '19px',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                }
            },
            '.pdf-text-detail': {
                display: 'flex',
                marginTop: "24px",
                '.pdf-text-detail-value': {
                    position: 'relative',
                    display: 'flex',
                    alignItems: 'center',
                    width: 'calc(100% - 150px)',
                    '.pdf-value-text': {
                        position: 'relative',
                        width: '100%'

                    }
                }
            },
        },
        '.pdf-container-signature': {
            marginTop: 'auto',
            display: 'flex',
            justifyContent: 'space-around',
            alignItems: ' center',
            width: '100%'
        }
    },
    '.text-break-word': {
        wordWrap: 'break-word',
        whiteSpace: 'normal',
        overflowWrap: 'break-word'
    },

}))

const PDFLineText = styled(Box)(({ theme }) => ({
    position: 'absolute',
    width: '150px',
    borderBottom: '1px dashed black'
}))

const StyledSignatureButton = styled(Button)`
  flex-grow: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  width: 300px;
  height: 138px;
  border: 1px dashed #e5e5e5;
  padding: 10px 0px;
  color: #808080;
  background-color: transparent;
  &:hover {
    border-color: #808080;
    background-color: #f5f5f5;
  }
  @media print {
     '.signature-button': {
        border: 'none !important',
    },
  }
`;

const Address_branches = [
    {
        id: 1,
        name: "ทองหล่อ",
        company: "THONGLOR DENTAL HOSPITAL CO.,LTD.",
        address: "61/6, SOI THONGLOR, SUKHUMVIT 55 ROAD, KLONGTON-NUA, WATTANA, BANGKOK 10110 THAILAND",
        contact: {
            T: "+66 (0) 2382 0044",
            M: "+66 (0) 88328 0044",
            F: "+66 (0) 2382 0036"
        },
        email: "INFO@THONGLORDENTALHOSPITAL.COM",
        website: "WWW.THONGLORDENTALHOSPITAL.COM"
    },
    {
        id: 2,
        name: "ปุณณวิถี",
        company: "THONGLOR DENTAL HOSPITAL CO.,LTD.",
        address: "2414, SUKHUMVIT ROAD, BANGJAK, PRAKANONG, BANGKOK 10260 THAILAND",
        contact: {
            T: "+66 (0) 2382 0044",
            M: "+66 (0) 88328 0044",
            F: "+66 (0) 2382 0036"
        },
        email: "INFO@THONGLORDENTALHOSPITAL.COM",
        website: "WWW.THONGLORDENTALHOSPITAL.COM"
    },
    {
        id: 3,
        name: "ราชพฤกษ์",
        company: "THONGLOR DENTAL HOSPITAL CO.,LTD.",
        address: "84/6 MOO 1, RATCHAPRUEK ROAD, BANGKANOON, BANGKRUAY, NONTHABURI 11130 THAILAND",
        contact: {
            T: "+66 (0) 2382 0044",
            M: "+66 (0) 88328 0044",
            F: "+66 (0) 2382 0036"
        },
        email: "INFO@THONGLORDENTALHOSPITAL.COM",
        website: "WWW.THONGLORDENTALHOSPITAL.COM"
    },
    {
        id: 4,
        name: "ติวานนท์",
        company: "THONGLOR DENTAL HOSPITAL TIWANON CO.,LTD.",
        address: "84/6 MOO 1, RATCHAPRUEK ROAD, BANGKANOON, BANGKRUAY, NONTHABURI 11130 THAILAND",
        contact: {
            T: "+66 (0) 2120 7437",
            M: "+66 (0) 95119 8119",
            F: "+66 (0) 2382 0036"
        },
        email: "INFO@THONGLORDENTALHOSPITAL.COM",
        website: "WWW.THONGLORDENTALHOSPITAL.COM"
    },
    {
        id: 5,
        name: "ไอคอนสยาม",
        company: "THONGLOR DENTAL HOSPITAL CO.,LTD.",
        address: "61/6, SOI THONGLOR, SUKHUMVIT 55 ROAD, KLONGTON-NUA, WATTANA, BANGKOK 10110 THAILAND",
        contact: {
            T: "+66 (0) 2382 0044",
            M: "+66 (0) 88328 0044",
            F: "+66 (0) 2382 0036"
        },
        email: "INFO@THONGLORDENTALHOSPITAL.COM",
        website: "WWW.THONGLORDENTALHOSPITAL.COM"
    },
    {
        id: 6,
        name: "เวียงจันทน์",
        company: "VIENTIANE DENTAL HOSPITAL INTERNATIONAL CO.,LTD.",
        address: "UNIT 01, BAN WAT NA , SISATTANAK DISTRICT, VIENTIANE MUNICIPALITY, LAO P.D.R. 01030",
        contact: {
            TEL: "+856 (0) 21 316 799",
            MOBILE_WHATSAPP: "+856 (0) 20 5995 9779"
        },
        email: "INFO@THONGLORDENTALHOSPITAL.COM",
        website: "WWW.THONGLORDENTALHOSPITAL.COM"
    },
    {
        id: 7,
        name: "แคนวาส",
        company: "THONGLOR DENTAL HOSPITAL CO.,LTD.",
        address: "546 CANVAS PLOENCHIT BUILDING,UNIT 602, PATHUMWAN BANGKOK 10330 THAILAND",
        contact: {
            TEL: "02-382-0044",
            MOBILE: "0618798800"
        },
        email: "INFO@THONGLORDENTALHOSPITAL.COM",
        website: "WWW.THONGLORDENTALHOSPITAL.COM"
    }
];


type PdfInvoiceProps = {
    type: 'treatment' | 'historyTreatment' | 'payment'
    docterId: any
    noteNextVisit: any
    treatment: any
    childrenModal?: ReactNode
    openModal: (type: 'doctor' | 'patient') => void
    clear?: boolean
    disabledBtn?: boolean
    submit?: boolean
    onSubmit: (e: boolean) => void
}

const PdfInvoice = (props: PdfInvoiceProps) => {
    const { treatment } = props
    const { t } = useTranslation()
    const dispatch = useDispatch()
    const currentInvoice = useSelector(selectCurrentInvoice);
    const [textRemark, setTextRemark] = useState<string[]>([''])
    const [lineRemark, setLineRemark] = useState<number>(1)
    const [textNextVisit, setTextNextVisit] = useState<string[]>([''])
    const [noteNextVisit, setNoteNextVisit] = useState<string>('')
    const [lineNextVisit, setLineNextVisit] = useState<number>(1)
    const [totalTreatment, setTotalTreatment] = useState<number>(0)
    const [isOpenPageModal, setIsOpenPageModal] = useState(false)


    const textRemarkRef = useRef<any>(null)
    const textNextVisitRef = useRef<any>(null)

    const BranchInfo = getClinicInfo()

    const headCells = [
        { title: t('PDF_INVOICE.PDF.NO'), title_en: t('PDF_INVOICE.PDF.NO_EN'), style: { width: '70px' } },
        { title: t('PDF_INVOICE.PDF.CODE'), title_en: t('PDF_INVOICE.PDF.CODE_EN'), style: { width: '70px' } },
        { title: t('PDF_INVOICE.PDF.TREATMENT_LIST'), title_en: t('PDF_INVOICE.PDF.TREATMENT_LIST_EN'), style: { width: 'auto' } },
        { title: t('PDF_INVOICE.PDF.QUANTITY'), title_en: t('PDF_INVOICE.PDF.QUANTITY_EN'), style: { width: '100px' } },
        { title: t('PDF_INVOICE.PDF.PRICE'), title_en: t('PDF_INVOICE.PDF.PRICE_EN'), style: { width: '120px' } },
    ]



    useEffect(() => {
        renderTextDetail()
        handleTotalTreatment()
    }, [treatment])

    const handleTotalTreatment = () => {
        const newTotalPD = treatment?.summeryProducts?.map((item: any) => item?.total || 0)
            .reduce((accumulator: number, currentValue: number) => accumulator + currentValue, 0);
        const newTotal = treatment?.summeryTreatments?.map((treatment: any) => treatment?.total || 0)
            .reduce((accumulator: number, currentValue: number) => accumulator + currentValue, 0);
        setTotalTreatment((newTotal + newTotalPD) || 0)
    }

    const handlePatientCode = () => {
        if (BranchInfo?.patientCodeAppointment === '1') {
            return treatment?.patientInfo?.cnNumber || '-'
        } else if (BranchInfo?.patientCodeAppointment === '0') {
            return treatment?.patientInfo?.branchCnNumber || '-'
        } else if (BranchInfo?.patientCodeAppointment === '2') {
            return treatment?.patientInfo?.snCode || '-'
        } else {
            return '-'
        }
    }

    const renderTextDetail = useCallback(() => {

        const handleTreatment = (data: string) => {
            const dataTreatment = JSON.parse(data)
            const textTreatment: string[] = []
            dataTreatment?.forEach((item: any) => {
                textTreatment.push(item?.operativeName || item?.operativeTypeName)
            })
            return textTreatment.toString()
        }

        const newTextRemark: string[] = []
        const newTextNextVisit: string[] = []
        treatment?.summeryTreatments?.forEach((item: any) => {
            const dataNV = item?.nextVisit
            newTextRemark.push(item.note)
            if (dataNV?.date) {
                // thai
                newTextNextVisit.push(`วันที่: ${dateToView(dataNV?.date)} ${moment(dataNV?.timeStart, 'HH:mm:ss').format('HH:mm')} ${dataNV?.prefix || ''} ${dataNV?.doctorFullname} บริการ: ${handleTreatment(dataNV?.treatment)}`)
            }

        })

        setNoteNextVisit(
            props.noteNextVisit
                .filter((e: any) => e.doctorId === treatment.doctorId)
                .map((e: any) => e.noteNextVisit)
        );
        setTextRemark(newTextRemark)
        setTextNextVisit(newTextNextVisit)
    }, [treatment])

    useEffect(() => {
        if (textRemarkRef?.current) {
            setLineRemark((textRemarkRef?.current?.clientHeight / 24) || 1)
        }
    }, [textRemarkRef?.current?.clientHeight, textRemark])

    useEffect(() => {
        if (textNextVisitRef?.current) {
            setLineNextVisit((textNextVisitRef?.current?.clientHeight / 24) || 1)
        }
    }, [textNextVisitRef?.current?.clientHeight, textNextVisit])

    const onTableEmpty = useCallback(() => {
        const numberTotal = (treatment?.summeryTreatments?.length || 0) + (treatment?.summeryProducts?.length || 0)
        const numberTB = numberTotal >= 13 ? 0 : 13 - numberTotal
        return numberTB
    }, [treatment])


    const SignatureButton = ({ type, children, disabled, className }: { type: "doctor" | "patient", children: ReactNode, disabled?: boolean, className?: string; }) => {
        return (
            <StyledSignatureButton
                id="signature-button"
                className={`${className} signature-button`}
                disabled={disabled ?? false}
                variant="outlined"
                onClick={() => {
                    props.openModal(type);
                    props.onSubmit(false);
                    setIsOpenPageModal(true);
                }}
            >{children}</StyledSignatureButton>
        );
    };

    const handleSignature = (type: "submit" | "clear") => {
        type === 'submit' ? props.onSubmit(true) : props.onSubmit(false)
        setIsOpenPageModal(false);
    };

    return (
        <>
            <PDFContainer>
                {Config.IS_TDH === '1' && (<Box style={{ position: 'absolute', top: '50px', right: '50px' }}>
                    <Box sx={{
                        height: '50px',
                        width: '200px',
                        border: '1px solid black',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center'
                    }}><Typography>{Address_branches[BranchInfo.branchId - 1]?.name}</Typography>
                    </Box>
                </Box>)}
                <Box className={'pdf-body'} style={{ position: 'absolute', top: '0px' }}>
                    <Box display="flex" justifyContent="center" >
                        <Box className={'pdf-title'} >
                            <Box className={'pdf-branch-logo'} ><img src={BranchInfo?.branchLogo || ''} /></Box>
                            <Box className={'pdf-title-text'} sx={{ fontSize: '20px' }}>{t("PDF_INVOICE.TITLE")}</Box>
                            <Box className={'pdf-title-text'} sx={{ fontSize: '18px' }}>{t("PDF_INVOICE.TITLE_EN")}</Box>
                        </Box>
                    </Box>
                    <Box className={'pdf-content'}>
                        <Box className={'pdf-content-date'} >
                            <span style={{ fontWeight: '500' }}>{t("PDF_INVOICE.PDF.DATE")}/{t("Date")}</span>
                            <span style={{ width: '200px', display: 'flex', justifyContent: 'flex-end' }}>&nbsp;&nbsp;{dateMonthToView(new Date(), true)}</span>
                            <PDFLineText sx={{ bottom: '0', }} />
                        </Box>
                        <Box sx={{ display: 'flex', marginTop: '8px' }}>
                            <Box sx={{ width: '60%' }}>
                                <Box sx={{ fontWeight: '500', }}>
                                    <span>{t('PDF_INVOICE.PDF.PATIENT_NAME')}/{t('PDF_INVOICE.PDF.SUB_PATIENT_NAME')}</span><span>&nbsp;&nbsp;{`${treatment?.patientInfo?.firstname} ${treatment?.patientInfo?.lastname}`}</span>
                                </Box>
                            </Box>
                            <Box>
                                <Box sx={{ fontWeight: '500', }}>
                                    <span>{t('PDF_INVOICE.PDF.PATIENT_ID')}/{t('PDF_INVOICE.PDF.SUB_PATIENT_ID', { patientCodeQueue: BranchInfo?.patientCodeQueue === '0' ? 'PT' : BranchInfo?.patientCodeQueue === '1' ? 'CN' : 'SN' })}</span><span>&nbsp;&nbsp;{handlePatientCode()}</span>
                                </Box>
                            </Box>
                        </Box>

                        <Box className={'pdf-table-container'}>
                            <table>
                                <tr className={'table-head'}>
                                    {headCells.map((item, index: number) => {
                                        return (
                                            <th key={index} style={{ ...item?.style }}>
                                                <Box>{item.title}</Box>
                                                <Box>{item.title_en}</Box>
                                            </th>
                                        )
                                    })}
                                </tr>
                                {treatment?.summeryTreatments && treatment?.summeryTreatments?.map((item: any, index: number) => {
                                    if (index <= 12) {
                                        return (
                                            <tr className={'table-body'} key={index}>
                                                <td style={{ textAlign: 'center', maxWidth: '70px' }}>{index + 1}</td>
                                                <td style={{ textAlign: 'center', maxWidth: '120px' }}>{item?.operativeCode || ''}</td>
                                                <td style={{ maxWidth: '600px' }}>{item?.operativeName}</td>
                                                <td style={{ textAlign: 'center', maxWidth: '100px' }} >{item?.qty || 0}</td>
                                                <td style={{ textAlign: 'right', maxWidth: '120px' }}>{numberFormat(item?.total || 0)}</td>
                                            </tr>
                                        )
                                    }
                                })}
                                {treatment?.summeryProducts && treatment?.summeryProducts?.map((item: any, index: number) => {
                                    if (((treatment?.summeryTreatments?.length || 0) + index) <= 12) {
                                        return (
                                            <tr className={'table-body'} key={index}>
                                                <td style={{ textAlign: 'center', maxWidth: '70px' }}>{index + 1 + (treatment?.summeryTreatments?.length || 0)}</td>
                                                <td style={{ textAlign: 'center', maxWidth: '120px' }}>{item?.itemCode || ''}</td>
                                                <td style={{ maxWidth: '600px' }}>{item?.itemName || ''}</td>
                                                <td style={{ textAlign: 'center', maxWidth: '100px' }} >{item?.qty || 0}</td>
                                                <td style={{ textAlign: 'right', maxWidth: '120px' }}>{numberFormat(item?.total || 0)}</td>
                                            </tr>
                                        )
                                    }
                                })}
                                {new Array(onTableEmpty())?.fill(undefined)?.map((item, index: number) => {
                                    return (
                                        <tr className={'table-body'} key={index}>
                                            {new Array(5).fill(undefined).map((info, num: number) => (
                                                <td key={num} >
                                                    <Box sx={{ height: '24px', }}>
                                                    </Box>
                                                </td>
                                            ))}
                                        </tr>
                                    )
                                })}
                                <tr style={{ fontWeight: '500' }}>
                                    <td colSpan={3} >
                                    </td>
                                    <td style={{ textAlign: 'center', padding: '8px 8px ', border: '1px solid blue', }} >
                                        <Box sx={{ minHeight: '19px' }}>
                                            <Box>
                                                {t('PDF_INVOICE.PDF.TOTAL')}
                                            </Box>
                                            <Box>
                                                {t('PDF_INVOICE.PDF.TOTAL_EN')}
                                            </Box>
                                        </Box>
                                    </td>
                                    <td style={{ border: '1px solid blue', padding: '8px', textAlign: 'right', }}>
                                        <Box sx={{ minHeight: '19px' }}>
                                            {numberFormat(totalTreatment)}
                                        </Box>
                                    </td>
                                </tr>
                            </table>
                        </Box>

                        <Box className={'pdf-text-detail'}>
                            <Box>
                                <Box sx={{ fontWeight: '500', width: '150px' }}>{t('PDF_INVOICE.PDF.REMARK')}/ {t('PDF_INVOICE.PDF.REMARK_EN')} :</Box>
                            </Box>
                            <Box className={'pdf-text-detail-value'}>
                                <Box className={'pdf-value-text pdf-text-remark text-break-word'} ref={textRemarkRef} >
                                    {textRemark.filter((item) => item !== '').join('; ')}
                                    {new Array(lineRemark).fill(undefined).map((item: any, index: any) =>
                                        <PDFLineText
                                            key={index}
                                            sx={{
                                                top: `${23 * (index + 1)}px`,
                                                width: '100% !important',
                                            }}
                                        />
                                    )}
                                </Box>
                            </Box>
                        </Box>

                        <Box className={'pdf-text-detail'} sx={{ marginTop: "40px !important" }}>
                            <Box><Box sx={{ fontWeight: '500', width: '290px' }}>{t('PDF_INVOICE.PDF.NEXT_VISIT')}/{t('PDF_INVOICE.PDF.NEXT_VISIT_EN')} :</Box></Box>
                            <Box className={'pdf-text-detail-value'}>
                                <Box className={'pdf-value-text pdf-text-next-visit text-break-word'} ref={textNextVisitRef} >
                                    {noteNextVisit}
                                    {new Array(lineNextVisit).fill(undefined).map((item: any, index: any) =>
                                        <PDFLineText
                                            key={index}
                                            sx={{
                                                top: `${23 * (index + 1)}px`,
                                                width: '100% !important',
                                            }}
                                        />
                                    )}
                                </Box>
                            </Box>
                        </Box>
                    </Box>
                    <Box sx={{ position: 'absolute', bottom: '70px', width: "calc(100% - 120px)" }}>
                        <Box display="flex" justifyContent="space-between">
                            <Box sx={{ textAlign: 'center' }}>
                                {currentInvoice?.doctorSignature ?
                                    <Box marginY='10px'>
                                        <SignatureButton type='doctor' disabled={(treatment?.invoice?.doctorSignature && treatment?.invoice?.patientSignature) || props.disabledBtn}>
                                            <img src={`data:image/png;base64,${currentInvoice?.doctorSignature}`} style={{ width: '178px', height: '130px' }} />
                                        </SignatureButton>
                                    </Box> : <Box marginBottom={'20px'}>
                                        <SignatureButton type='doctor' disabled={(treatment?.invoice?.doctorSignature && treatment?.invoice?.patientSignature) || props.disabledBtn}>
                                            <BtnEditUnderline color={'#808080'} width='35' height='35' />
                                            <Typography sx={{ fontWeight: '500', fontSize: '20px' }}>{t(`PDF_INVOICE.PDF.CLICK_SIGNATURE`)}</Typography>
                                        </SignatureButton>
                                    </Box>}
                                <Box>
                                    <Box sx={{ borderBottom: "1px dashed black", width: "200px", margin: "0 auto" }} />
                                    <Typography
                                        sx={{
                                            fontWeight: "500",
                                            fontSize: 14,
                                            textDecoration: "underline",
                                            textDecorationStyle: "dotted",
                                            textDecorationColor: "#000",
                                            marginBottom: '8px',
                                            marginTop: '10px'
                                        }}
                                    >{`( ${treatment?.firstname} ${treatment?.lastname} )`}
                                    </Typography>
                                    <Typography sx={{ fontSize: 14, marginBottom: '8px' }}>{t('PDF_INVOICE.PDF.DOCTOR_SIGNATURE')}</Typography>
                                    <Typography sx={{ fontSize: 14, marginBottom: '8px' }}>{t('PDF_INVOICE.PDF.DOCTOR_SIGNATURE_EN')}</Typography>
                                </Box>
                            </Box>
                            <Box sx={{ textAlign: 'center' }}>
                                {currentInvoice?.patientSignature ?
                                    <Box marginY='10px'>
                                        <SignatureButton type='patient' disabled={treatment?.invoice?.doctorSignature && treatment?.invoice?.patientSignature}>
                                            <img src={`data:image/png;base64,${currentInvoice?.patientSignature}`} style={{ width: '178px', height: '130px' }} />
                                        </SignatureButton>
                                    </Box>
                                    : <Box marginBottom={'20px'}>
                                        <SignatureButton type='patient' disabled={treatment?.invoice?.doctorSignature && treatment?.invoice?.patientSignature}>
                                            <BtnEditUnderline color={'#808080'} width='35' height='35' />
                                            <Typography sx={{ fontWeight: '500', fontSize: '20px' }}>{t(`PDF_INVOICE.PDF.CLICK_SIGNATURE`)}</Typography>
                                        </SignatureButton>
                                    </Box>}
                                <Box>
                                    <Box sx={{ borderBottom: "1px dashed black", width: "200px", margin: "0 auto" }} />
                                    <Typography sx={{
                                        fontWeight: "500",
                                        fontSize: 14,
                                        textDecoration: "underline",
                                        textDecorationStyle: "dotted",
                                        textDecorationColor: "#000",
                                        marginBottom: '8px',
                                        marginTop: '10px'
                                    }}>{`( ${treatment?.patientInfo?.firstname} ${treatment?.patientInfo?.lastname} )`}</Typography>
                                    <Typography sx={{ fontSize: 14, marginBottom: '8px' }}>{t('PDF_INVOICE.PDF.PATIENT_SIGNATURE')}</Typography>
                                    <Typography sx={{ fontSize: 14, marginBottom: '8px' }}>{t('PDF_INVOICE.PDF.PATIENT_SIGNATURE_EN')}</Typography>
                                </Box>
                            </Box>
                        </Box>

                        {Config.IS_TDH === '1' ?
                            <Box display="flex" justifyContent="space-between" alignItems="center" sx={{ marginTop: 0 }}>
                                <Box sx={{ width: "20%", textAlign: "left" }}></Box>
                                <Box sx={{ width: "60%", textAlign: "center", marginTop: "20px" }}>
                                    <Box className="pdf-branch-name" sx={{ fontWeight: "600", }}>{`${Address_branches[BranchInfo.branchId - 1]?.company}`}</Box>
                                    <Box className="pdf-branch-address">{`${Address_branches[BranchInfo.branchId - 1]?.address}`}</Box>
                                    <Box className="pdf-branch-phone">
                                        <span style={{ fontWeight: "600" }}>{`T`}</span> {`${Address_branches[BranchInfo.branchId - 1]?.contact.T}`}
                                        <span style={{ fontWeight: "600" }}> {`M`}</span> {`${Address_branches[BranchInfo.branchId - 1]?.contact.M}`}
                                        <span style={{ fontWeight: "600" }}> {`F`}</span> {`${Address_branches[BranchInfo.branchId - 1]?.contact.F}`}
                                    </Box>
                                    <Box className="pdf-branch-phone" sx={{ fontWeight: "400", fontSize: "14px" }}>{`${Address_branches[BranchInfo.branchId]?.email}`} {`${Address_branches[BranchInfo.branchId - 1]?.website}`}</Box>
                                </Box>
                                <Box sx={{ width: "20%", textAlign: "right", position: "relative" }}><img src={logo.logoInvoice} height={70} /></Box>
                            </Box> : <Box display="flex" justifyContent="center" alignItems="center" sx={{ marginTop: 0 }}>
                                <Box sx={{ width: "60%", textAlign: "center", marginTop: "20px" }}>
                                    <Box className="pdf-branch-name" sx={{ fontWeight: "500" }}>{BranchInfo?.branchName || ""} </Box>
                                    <Box className="pdf-branch-address">{BranchInfo?.receiptFullAddress || ""}</Box>
                                    <Box className="pdf-branch-phone">{BranchInfo?.branchPhone || ""}</Box>
                                </Box>
                            </Box>
                        }
                    </Box>
                    {/* <Modal
                        open={isOpenPageModal}
                        onClose={() => handleSignature("clear")}
                        sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            '.card-ap-detail': {
                                position: 'unset',
                                transform: 'none '
                            }
                        }}
                    ><><Box>{props.childrenModal}</Box></>
                    </Modal> */}

                    <PageModal
                        isOpen={isOpenPageModal}
                        size={'S'}
                        title={t('PDF_INVOICE.PDF.SIGNATURE')}
                        handleClose={() => handleSignature("clear")}
                        onSubmit={{ onClick: () => handleSignature("submit") }}
                        onCancel={{ onClick: () => handleSignature("clear") }}
                        overflow
                    >{props.childrenModal}</PageModal>
                </Box>
            </PDFContainer >
        </>
    )
}

export default PdfInvoice